import { arrayIfy } from '@provision/formatting-utils';
import type { KeyboardEvent } from 'react';
import { UserGroupRules } from 'src/graphql';

export function hasBulkUpdateActionAccess(
  bulkUpdateAction: { accessRuleKey?: string[] | string },
  groupRules: Record<string, boolean | number[] | undefined>,
): boolean {
  const accessRuleKeys = arrayIfy(bulkUpdateAction.accessRuleKey);

  if (!accessRuleKeys.length) {
    return true;
  }

  return accessRuleKeys.every((ruleKey) => {
    const resolvedAccessRule =
      UserGroupRules[ruleKey as keyof typeof UserGroupRules] ?? (ruleKey as UserGroupRules);
    return Boolean(groupRules[resolvedAccessRule]);
  });
}

export function shouldShowBulkUpdateAction(
  bulkUpdateAction: {
    accessRuleKey?: string[] | string;
    updateAttribute?: string;
  },
  groupRules: Record<string, boolean | number[] | undefined>,
): boolean {
  if (bulkUpdateAction.updateAttribute === 'conversationStatusId') {
    return true;
  }

  return hasBulkUpdateActionAccess(bulkUpdateAction, groupRules);
}

// ModalContainer submits its primary action on Enter inside a text field; the filter dialogs
// apply live and Enter there never closed them.
export function preventEnterSubmit(event: KeyboardEvent<HTMLElement>): void {
  if (event.key === 'Enter' && event.target instanceof HTMLInputElement) {
    event.preventDefault();
  }
}
